module.exports = __webpack_public_path__ + "static/mobby-candidato-banner-desktop-5d105abce2e214f1d8e3f0ca791177bc.png";